import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AttachmentComponent } from 'src/app/attachment/attachment.component';
import { AuditDialogComponent } from 'src/app/history/audit-dialog/audit-dialog.component';
import { OpenConfirmDialogComponent } from 'src/app/history/open-confirm-dialog/open-confirm-dialog.component';
import { ModalComponent } from 'src/app/modal/modal.component';
import { PreviewEmailDialogComponent } from 'src/app/preview-email-dialog/preview-email-dialog.component';
import { EmailStatus } from '../model/emailstatus';
import { StakeholderEmail } from '../model/stakeholder-email';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(
    private dialog: MatDialog
  ) { }

  closeAll(){
    this.dialog.closeAll();
  }

  openAttachments(email: StakeholderEmail): MatDialogRef<ModalComponent, any>{
    const dialogRef = this.dialog.open(ModalComponent, {
      width: '60vw',
      maxHeight: '90vh',
      data: {
        title: `Attachments`,
        email,
        component: AttachmentComponent
      }
    });
    return dialogRef;
  }

  openConfirmEmail(): MatDialogRef<OpenConfirmDialogComponent, any>{
    const dialogRef = this.dialog.open(OpenConfirmDialogComponent, {
      disableClose: true
    });
    return dialogRef;
  }

  openAudit(rows: EmailStatus[]): MatDialogRef<AuditDialogComponent, any>{
    const dialogRef = this.dialog.open(AuditDialogComponent, {
      maxHeight: 'calc(100vh - 32px)',
      //width: '250px',
      data: { emailstatuses: rows }
    });
    return dialogRef;
  }

  openPreviewEmail(config: any): MatDialogRef<PreviewEmailDialogComponent, any>{
    const dialogRef = this.dialog.open(PreviewEmailDialogComponent, config);
    return dialogRef;
  }

}
